import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface SectionCardProps {
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  href: string;
  buttonText?: string;
  className?: string;
}

export function SectionCard({
  title,
  description,
  image,
  imageAlt,
  href,
  buttonText = "Oglej si več",
  className,
}: SectionCardProps) {
  return (
    <Link
      to={href}
      className={cn(
        "group relative overflow-hidden rounded-xl bg-card shadow-lg hover-scale",
        "transition-all duration-300 hover:shadow-xl",
        className
      )}
    >
      {/* Image */}
      <div className="relative h-64 md:h-80 overflow-hidden">
        <img
          src={image}
          alt={imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
      </div>

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
        <h3 className="text-white text-2xl md:text-3xl font-semibold mb-2">
          {title}
        </h3>
        <p className="text-white/90 mb-4 line-clamp-2">{description}</p>
        <Button
          variant="secondary"
          className="group-hover:bg-accent group-hover:text-accent-foreground transition-colors"
        >
          {buttonText}
          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Button>
      </div>
    </Link>
  );
}
